// eslint-disable-next-line import/no-extraneous-dependencies
import moment from "moment";
import { dateFormat, dateTimeFormat } from "./constants";

export function formateNumber(number) {
  return new Intl.NumberFormat("en-US").format(number);
}
export function formateResponse(data) {
  return data?.map((item) => ({
    ...item,
    deleteId: crypto.randomUUID(),
  }));
}

const PAYLOAD_STEPS = ["cash", "coins", "valuables", "documents"];

export function createPayload(data, step, consignments, exchangeRate) {
  const consignmentType = PAYLOAD_STEPS[step];
  data["deleteId"] = crypto.randomUUID();
  data["exchangeRate"] = exchangeRate;

  const containerObj = {
    details: data?.details,
    count: data?.count ?? 1,
    remarks: "",
    consignmentType: capitalizeFirstLetter(consignmentType),
    containerType: data?.containerType,
    containerId: data?.containerId,
    sealNo: data?.sealNo,
    localValue: data?.localValue,
    currency: () => {
      if (consignmentType === "coins") {
        return "AED";
      } else if (consignmentType === "documents") {
        return "";
      }
      return data?.currency;
    },

    declaredValue: data?.declaredValue,
    exchangeRate: consignmentType === "coins" ? 1 : data?.exchangeRate,
    deleteId: data["deleteId"],
  };

  const containers = consignments?.length
    ? [...consignments, containerObj]
    : [containerObj];
  return containers;
}

export function capitalizeFirstLetter(string) {
  return string?.[0]?.toUpperCase() + string?.slice(1);
}

export const formateUtcToLocalDateTime = (date, formate) => {
  if (formate) {
    return moment(date, formate).format(dateTimeFormat);
  }
  return moment.utc(date).local().format(dateTimeFormat);
};

export const formateUtcToLocalDate = (date, formate) => {
  if (formate) {
    return moment.utc(date, formate).local().format(dateFormat);
  }
  return moment.utc(date).local().format(dateFormat);
};

export function HasPermission(user, role, permission) {
  if (permission) {
    if (user.Permissions.includes(`${role}-${permission}`)) {
      return true;
    }
    return false;
  }
  if (user.Permissions.includes(`${role}`)) {
    return true;
  }

  return false;
}

export const getPasswordValidationStatus = (password) => ({
  minLength: password.length >= 8,
  specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  number: /[0-9]/.test(password),
  capital: /[A-Z]/.test(password),
  lowercase: /[a-z]/.test(password),
});

export async function encryptPassword(plainPassword, key) {
  try {
    // Convert plain password to UTF-8 bytes
    const plainData = new TextEncoder().encode(plainPassword);

    // Process the key to get 32 bytes (AES-256 requires 32-byte key)
    const keyBytes = new TextEncoder().encode(key);
    const truncatedKey = keyBytes.slice(0, 32);

    // Pad with zeros if key is shorter than 32 bytes
    const aesKey = new Uint8Array(32);
    aesKey.set(truncatedKey);

    // IV is all zeros (16 bytes) to match the C# version
    const iv = new Uint8Array(16);

    // Import the key
    const cryptoKey = await crypto.subtle.importKey(
      "raw",
      aesKey,
      { name: "AES-CBC" },
      false,
      ["encrypt"],
    );

    // Encrypt the data
    const encryptedData = await crypto.subtle.encrypt(
      {
        name: "AES-CBC",
        iv: iv,
      },
      cryptoKey,
      plainData,
    );

    // Convert to Base64
    const encryptedBytes = new Uint8Array(encryptedData);
    let base64 = "";
    for (let i = 0; i < encryptedBytes.byteLength; i++) {
      base64 += String.fromCharCode(encryptedBytes[i]);
    }
    return btoa(base64);
  } catch (error) {
    throw new Error("Failed to encrypt password");
  }
}

export async function decryptPassword(encryptedBase64, key) {
  try {
    // Decode Base64 to binary
    const encryptedBytes = Uint8Array.from(atob(encryptedBase64), (c) =>
      c.charCodeAt(0),
    );

    // Process the key (same as encryption: 32 bytes for AES-256)
    const keyBytes = new TextEncoder().encode(key);
    const truncatedKey = keyBytes.slice(0, 32);
    const aesKey = new Uint8Array(32);
    aesKey.set(truncatedKey);

    // Same IV (16 zero bytes) used during encryption
    const iv = new Uint8Array(16);

    // Import the key
    const cryptoKey = await crypto.subtle.importKey(
      "raw",
      aesKey,
      { name: "AES-CBC" },
      false,
      ["decrypt"],
    );

    // Decrypt the data
    const decryptedData = await crypto.subtle.decrypt(
      {
        name: "AES-CBC",
        iv: iv,
      },
      cryptoKey,
      encryptedBytes,
    );

    // Convert bytes back to string
    const decoder = new TextDecoder();
    return decoder.decode(decryptedData);
  } catch (error) {
    console.log(`Decrypt error on ${encryptedBase64}`);
    return "";
  }
}
export const formatExcelTimeToHHMMSS = (value) => {
  if (!value) return null;

  // If already string like 08:30 or 08:30:00
  if (typeof value === "string") {
    if (value.split(":").length === 2) {
      return `${value}:00`;
    }
    return value;
  }

  // If Excel numeric time (fraction of day)
  if (typeof value === "number") {
    const totalSeconds = Math.round(value * 24 * 60 * 60);
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
      2,
      "0",
    );
    const seconds = String(totalSeconds % 60).padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
  }

  return "00:00:00";
};

export const getLocalISODateString = (date) => {
  return `${moment(date).format("YYYY-MM-DD[T]HH:mm:ss[.000Z]")}`;
};
